import {Component,OnInit,Output,ViewChild,ElementRef, EventEmitter, Input, ChangeDetectorRef} from '@angular/core';
import {FormBuilder, FormControl, FormGroup,Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { OrganizationsService } from '../../services/organizationService/organization.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-create-organization',
  templateUrl: './create-organization.component.html',
  styleUrls: ['./create-organization.component.scss']
})
export class CreateOrganizationComponent implements OnInit {
  close: boolean = false;
  @Output() closeAdd = new EventEmitter<boolean>();
  @Output() closeAddAfterSave = new EventEmitter<boolean>();
  @Input() selectiontype:string="";
  @Input() organizationData:any=[]=[];
  showPasscode:boolean = false;
  organizationId: string;
  databaseId: string;
  admin:boolean = false;
  addOrganizationForm: FormGroup;
  hide = true;
  isActiveChecked:boolean=true;
  organizationTypeList: any[] = [];
  addOrgResponseHolder: any;
  ResponseHolder: any;
  organizatioDomainType: any[] = [];  
  showErrorMessage: boolean = false;
  currentUser: any;
  @Output() closeSidePanel = new EventEmitter();
  
  databaseName:string="";
  databaseNameShow:boolean=false;
  databaseNameShowExisting:boolean=false;
  databaseNameExisting:any=[]=[];
  databaseNameRuntime:any=[]=[];

  ExistingOrganizationName:string="";
  Setasadmin:boolean=false;
  
  @ViewChild('organizatioName', { static: true }) organizatioName: ElementRef; 
  @ViewChild('searchdatabaseNameExisting') searchdatabaseNameExistingclear: ElementRef;

  neworexisting:string="";
  databaseType:string="";
  importOfficeID:number=0;
  envname:string="";
  dbnameprefix:string="";
  hidecurrent = true;
  organizationDomainID:number=0;
  organizationID:number=0;
  DatabaseSetup:boolean=false;
  DatabaseType:boolean=false;
  SelectDatabaseName:boolean=false;
  DatabaseName:boolean=false;
  organizatioDomainTypeShow:boolean=false;
  spinner:boolean=false;

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue:string;
  objectList:any=[]=[];
  importOfficeFieldList:any=[]=[];
  OfficeIDList: any=[];
  myOfficeID: any;

  constructor(private formBuilder: FormBuilder,private customValidator: CustomvalidationService,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,private loaderService: LoaderService,
    private toastr: ToastrService, private organizationService: OrganizationsService, private constant: Constants,
    private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');   
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );   
  }

  states= this.objectList;

  private _filterStates(value: string): State[] {    
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnChanges(){
     this.selectiontype;
     this.organizationData;
     
     // this.organizatioName.nativeElement.focus();
    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;

     this.addOrganizationForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailregex)]],
      organizationName: ['', Validators.required],
      officeName: ['', Validators.required],
      selectoption: ['', Validators.required],
      organizatioDomainType: ['', Validators.required],
      representativePersonFirstName: ['', Validators.required],
      representativePersonLastName: ['', Validators.required],
      superPasscode:  [''],
      databaseName: ['', Validators.required],  
      databaseID:[0, Validators.required],
      password: ['',[this.customValidator.checkPassword.bind(this.customValidator)]],
     // password: ['',[Validators.required, this.customValidator.checkPassword.bind(this.customValidator),],],
      //phoneNumber: ['', [Validators.pattern(phoneNumberregex)],],
      //phoneNumber: [''],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)],],
      databaseType: ['', Validators.required],
      importFields: ['', ''],
      isActive: true,
    });
    
     if(this.organizationData!=undefined){      
       this.ExistingOrganizationName= this.organizationData.officeName;
       this.selectedOrgorganizationID= this.organizationData.organizationID;
     }
     if(this.selectiontype=="New"){
      this.selectedUserId='';
      this.DatabaseSetup=false;
      this.DatabaseType=false;
      this.SelectDatabaseName=false;
      this.organizatioDomainTypeShow=false;
      this.organizationID=0;
      this.addOrganizationForm.patchValue({
        officeName: " "
       });
     }
     if(this.selectiontype=="Existing"){ 
      this.DatabaseSetup=true;
      this.DatabaseType=true;
      this.SelectDatabaseName=true;
      this.organizatioDomainTypeShow=true;
      var checkdatabaseID = this.organizationData.databaseID;     
      if(checkdatabaseID>0 && checkdatabaseID!=undefined){
        this.neworexisting="Existing";
        this.databaseNameShowExisting=true;
        this.databaseNameExisting=this.databaseNameRuntime.filter((s) => s.databaseID==checkdatabaseID);
        this.addOrganizationForm.patchValue({
          databaseID: checkdatabaseID,
          databaseType:this.organizationData.databaseType,
          databaseName: " "
         });       
      }
      if(checkdatabaseID==0 && checkdatabaseID!=undefined){
        this.neworexisting="New";
        this.databaseNameShow=true;
        this.DatabaseName=true;
        this.addOrganizationForm.patchValue({
          databaseName: this.organizationData.databaseName
         });
      }
      this.organizationID=this.organizationData.organizationID;
      this.addOrganizationForm.patchValue({
        organizationName: this.ExistingOrganizationName,
        organizatioDomainType: this.organizationData.organizationDomainID,
        representativePersonFirstName: "",
        representativePersonLastName: "",
        email: "",
        phoneNumber : "",
        // representativePersonFirstName: this.organizationData.contactFirstName,
        // representativePersonLastName: this.organizationData.contactLastName,
        // email: this.organizationData.email,
        // phoneNumber :this.organizationData.phoneNumber,
        isActive: this.organizationData.isActive,
        selectoption: this.neworexisting
       });
     }   
     this.cdr.detectChanges(); 
  }
  
  ngOnInit(): void {
   // this.organizatioName.nativeElement.focus();
    //const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
  
    this.organizationTypeList = [
      { id: 1, name: 'Shared' },
      { id: 2, name: 'Dedicated' },
      { id: 3, name: 'Dedicated Shared' },
    ];
    // this.importOfficeFieldList = [
    //   { officeId: 1, name: 'Office1 : Healthcare' },
    //   { officeId: 2, name: 'Office2 : Facility' },
    //   { officeId: 3, name: 'Office3 : HR' },
    // ];
    if(this.constant.envProd) {
      this.dbnameprefix="Prod_";
      this.envname="Prod_";
    }else{
      this.dbnameprefix="Staging_";
      this.envname="Staging_";
    }    
    this.GetActiveOfficesSuperAdmin();
    this.getDatabases();
    this.getOrganizationDomainsType();
  }
  
  getOrganizationDomainsType(){
    var ReqModel={
      pageIndex: 0,
      pageSize: 100,
      searchKey: ""
    }
    this.organizationService.getOrganizationDomains(ReqModel).subscribe((response) => {
      if (response) {
        this.ResponseHolder = response;
        if(this.ResponseHolder.status == this.statusConst.statusSuccess) {          
          this.organizatioDomainType =this.ResponseHolder.data.organizationDomains;
        }
      }
    });
  } 
    
  onRadiobuttonChange(e) {
    if(e.source.value == 'New'){
      this.neworexisting="New";
      if(this.databaseType!=""){
        this.databaseNameShow=true;
        this.databaseNameShowExisting=false;
        this.addOrganizationForm.patchValue({
          databaseID:0
         });
         this.addOrganizationForm.controls.databaseName.setValue(null);       
      }    
    }
    if(e.source.value == 'Existing'){
      this.neworexisting="Existing";
      this.addOrganizationForm.patchValue({
        databaseName: " "
       });
       this.addOrganizationForm.controls.databaseID.setValue(null);
      if(this.databaseType!=""){
        this.databaseNameShowExisting=true;
        this.databaseNameShow=false;
        if(this.databaseNameRuntime.length>0){
          this.databaseNameExisting=this.databaseNameRuntime.filter((s) => s.databaseType==this.databaseType);
         }
      }
    }
  }  

  SelectiondatabaseType(event:any) {
    this.databaseType=event.value;
    //1-Shared, 2-Dedicated   
    if(this.neworexisting=="New"){
    this.databaseNameShow=true;
    this.databaseNameShowExisting=false;
    this.addOrganizationForm.patchValue({
      databaseID:0
     });
     this.addOrganizationForm.controls.databaseName.setValue(null);     
    }

    if(this.neworexisting=="Existing"){
      this.databaseNameShowExisting=true;
      this.databaseNameShow=false;
      if(this.databaseNameRuntime.length>0){
        this.databaseNameExisting=this.databaseNameRuntime.filter((s) => s.databaseType==event.value);
       }         
         this.addOrganizationForm.patchValue({
          databaseName: " "
         });
         this.addOrganizationForm.controls.databaseID.setValue(null);  
    }
  
  }

  SelectionImportField(event:any) {
    this.importOfficeID=event.value;
  }

  checkSetasadmin(event:MatCheckboxChange): void {
    if(event.checked==true){
      this.Setasadmin=true;
      this.admin=true;
      this.addOrganizationForm.get('password').setValidators(Validators.required);     
    }else{
      this.Setasadmin=false;
      this.admin=false;
      this.addOrganizationForm.get('password').clearValidators();
      this.addOrganizationForm.get('password').updateValueAndValidity();   
    }
    
  }

  getDatabases(){
    this.organizationService.getDatabases().subscribe((response) => {
      if (response) {
        this.ResponseHolder = response;
        if(this.ResponseHolder.status == this.statusConst.statusSuccess) {          
          this.databaseNameRuntime =this.ResponseHolder.data;
          if(this.databaseNameRuntime!=undefined)
            this.databaseNameExisting=this.databaseNameRuntime.filter((s) => s.databaseID==this.organizationData.databaseID);
        }
      }
    });
  }


  addOrganization(formValues) {
    this.spinner=true;
    this.addOrganizationForm.markAsPristine();
    if(this.Setasadmin==true){

      var officeIDs=[];
      if(this.OfficeUsingSelectedUser.length>0){
        for (let i = 0; i < this.OfficeUsingSelectedUser.length; i++) {       
          officeIDs.push(this.OfficeUsingSelectedUser[i].officeID);
        }
      }else{
        officeIDs=null;
      }
      var objadministrator= {
        firstName: formValues.representativePersonFirstName,
        lastName:  formValues.representativePersonLastName,
        phoneNumber:  formValues.phoneNumber,
        email:  formValues.email,
        password: formValues.password,
        roleLevel:this.selectiontype=="New"?2:3,
        organizationID:this.selectedOrgorganizationID,
        officeID: officeIDs,
        userID: this.selectedUserId
      }  
    }    
    if (formValues != undefined) {
      let selectedOffice= this.importOfficeFieldList.find(m=>m.officeID==this.importOfficeID);
      var ReqModel={
        organizationDomainID: formValues.organizatioDomainType,
        userID: this.currentUser.UID,
        organizationID: this.organizationID,
        databaseID: formValues.databaseID,
        databaseName : formValues.databaseID==0 ?this.envname+formValues.databaseName.trim(): "",
        databaseType : formValues.databaseType,
        secureKey : formValues.superPasscode,
        cloneOfficeID:selectedOffice!=undefined? selectedOffice.officeID:0,
        cloneOrganizationID:selectedOffice!=undefined?selectedOffice.organizationID:0,
        office: {
          officeID: 0,
          officeName: this.selectiontype=="New"?formValues.organizationName:formValues.officeName, //formValues.organizationName,  // Org Name
          isHeadOffice: this.selectiontype=="New"?true:false, // New Org(true), existing org (false)
          location: {
           address1: "",
           address2: "",
           cityID: 0,
           stateID: 0,
           countryID: 0,
           zipCode: ""
          },
          isActive : this.isActiveChecked,     
         },
        representative: {
          firstName: formValues.representativePersonFirstName,
          lastName:  formValues.representativePersonLastName,
          phoneNumber:  formValues.phoneNumber,
          email:  formValues.email
         },
        administrator:this.Setasadmin==true? objadministrator:null,  
      } 
    //  return;
      this.loaderService.show();
      this.organizationService.addOrganization(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.spinner=false;
            this.addOrgResponseHolder = response;
            if(this.addOrgResponseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.toastr.success(this.addOrgResponseHolder.message, '', {
                timeOut: 3000,
              });             
              this.closeListingAfterSave(false);              
            } else {
              this.spinner=false;
              this.loaderService.hide();
              this.toastr.error(this.addOrgResponseHolder.message, '', {
                timeOut: 3000,
              });             
              this.closeListingAfterSave(false);
              this.isActiveChecked=true;
              this.addOrganizationForm.controls.isActive.setValue(true);
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        });
    }
  }

  GetActiveOfficesSuperAdmin() {
     
      var ReqModel={
        officeID: 0,
        userID: this.currentUser.UID,
        organizationID:1,
        databaseId:this.databaseId
      } 
      this.organizationService.GetActiveOfficesSuperAdmin(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.spinner=false;
            if(response.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.importOfficeFieldList=response.data.organizations[0].offices!=null?response.data.organizations[0].offices:[];
              this.importOfficeFieldList =  [response.data.organizations[0]].concat(this.importOfficeFieldList);
               this.importOfficeFieldList[0].offices=null;
            } 
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        }); 
  }
  closeListingAfterSave(message: boolean) {
    this.selectedUserId='';
    this.OfficeUsingSelectedUser=[];
    this.databaseType="";
    this.neworexisting="";
    this.databaseNameShowExisting=false;
    this.databaseNameShow=false;
    this.Setasadmin=false;
    this.admin=false;
    this.showPasscode=false;
    this.DatabaseSetup=false;
    this.DatabaseType=false;
    this.SelectDatabaseName=false;
    this.DatabaseName=false;
    this.addOrganizationForm.reset();
    //this.searchdatabaseNameExistingclear.nativeElement.value='';   
    this.isActiveChecked=true;
    this.addOrganizationForm.controls.isActive.setValue(true);   
    this.closeAddAfterSave.emit(message);
    this.cdr.detectChanges();
  }


  closeListing(message: boolean) {
    this.selectedUserId='';
    this.OfficeUsingSelectedUser=[];
    this.databaseType="";
    this.neworexisting="";
    this.databaseNameShowExisting=false;
    this.databaseNameShow=false;
    this.Setasadmin=false;
    this.admin=false;
    this.showPasscode=false;
    this.DatabaseSetup=false;
    this.DatabaseType=false;
    this.SelectDatabaseName=false;
    this.DatabaseName=false;
    this.addOrganizationForm.reset();
    //this.searchdatabaseNameExistingclear.nativeElement.value='';   
    this.isActiveChecked=true;
    this.addOrganizationForm.controls.isActive.setValue(true);   
    this.closeAdd.emit(message);
    this.cdr.detectChanges();
  }
  
  checkDbName(event) {
    if(event.code=="Space"){
      event.preventDefault();
		  return false;
    }
		const regexp = new RegExp('^[!@#$&%^*()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {     
		  event.preventDefault();
		  return false;
		}else{
     
    }
  }

  onPasteDbName(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') || '';

  // Block if pasted text contains disallowed characters
  const invalidCharPattern = /[ !@#$&%^*()\-\`.+,\/"]/g;

  if (invalidCharPattern.test(pastedText)) {
    event.preventDefault();  // Block paste
   }
 }

  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.addOrganizationForm);
  }

  // Get Errors for password field
  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.addOrganizationForm);
  }

  /** Allow only Number */
  allowOnlyNumber(event) {
		const regexp = new RegExp('^([0-9])$');
		const result = regexp.test(event.key);
		if (!result) {
		  event.preventDefault();
		  return false;
		}
  }
  
  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.addOrganizationForm);
  }

  CheckStatus(event){
    if(event.checked==true){
      this.isActiveChecked=true;
    }else{
      this.isActiveChecked=false;
    }
  }

  
  emailList:any=[]=[];
  timeout = null;
  responseHolder: any;
  anonymousEmail:any=[]=[];
  selectedUserId:string="";
  OfficeUsingSelectedUser:any=[]=[];
  selectedOrgorganizationID:number=0;

  searchUser(val) {
    this.selectedUserId="";
    this.Setasadmin=false;
    this.OfficeUsingSelectedUser=[];
    // this.addOrganizationForm.patchValue({
    //  // representativePersonFirstName: "",
    //  // representativePersonLastName: "",
    //  // phoneNumber: ""
    //  // email: email.email,    
    //  });
    this.emailList=[];
      if(val.length>=2){       
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {      
       this.getAllEmail(val)
      }, 500);
    }else{
      this.selectedUserId="";
      this.Setasadmin=false;
      this.emailList=[];
      this.OfficeUsingSelectedUser=[];
      let  emailVerified:boolean=false;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      emailVerified = regexp.test(val);
      if(emailVerified==true){
      this.addOrganizationForm.patchValue({
        // representativePersonFirstName: "",
        // representativePersonLastName: "",
        // phoneNumber: ""
         email: val,
        });
      }else{
        this.addOrganizationForm.patchValue({
          // representativePersonFirstName: "",
          // representativePersonLastName: "",
          // phoneNumber: ""
           email: val,
          });
        //this.addOrganizationForm.markAsPristine();
      }
      // this.addOrganizationForm.patchValue({
      //  // representativePersonFirstName: "",
      //  // representativePersonLastName: "",
      //  // phoneNumber: ""
      //  // email: email.email,    
      //  });
    }
  }


  getAllEmail(searchValue: any) {
    var ReqModel = {
      pageIndex : 500,
      pageSize: 0,
      searchKey: searchValue,
      databaseID : Number(this.databaseId),
      organizationID : Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: 0         
    }
    this.organizationService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.emailList = response.data.userModel;         
       
          if(this.emailList.length>0){
            this.emailList.map((res) => {
              if (res.email != null) {
                res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
              }
              if (res.phoneNumber != null) {
                res.phoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.phoneNumber);
              }
              if (res.userName != null) {
                res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
              }
              if (res.firstName != null || res.lastName != null) {
                res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.firstName);
                res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.lastName);
                res.name=res.firstName + " "+ res.lastName;
              } 
              
              let  emailVerified:boolean=false;
              const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
              emailVerified = regexp.test(searchValue);
              if(emailVerified==true){
              this.addOrganizationForm.patchValue({            
                 email: searchValue,
                });
              }
              return res;
            });
          }else{
            let  emailVerified:boolean=false;
            const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            emailVerified = regexp.test(searchValue);
            if(emailVerified==true){
            this.addOrganizationForm.patchValue({            
               email: searchValue,
              });
            }
          }     
        }else{
          let  emailVerified:boolean=false;
          const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
          emailVerified = regexp.test(searchValue);
          if(emailVerified==true){
          this.addOrganizationForm.patchValue({            
             email: searchValue,
            });
          }
         // this.addOrganizationForm.markAsPristine();
          this.selectedUserId='';
          this.emailList=[];
        }
       }
     })
  }

 

  emailSelected(email: any) {
    this.selectedUserId=email.uuid;

    this.addOrganizationForm.patchValue({     
      representativePersonFirstName: email.firstName,
      representativePersonLastName: email.firstName,
      email: email.email, 
      phoneNumber: email.phoneNumber.substring(2)
     });

     this.OfficeUsingSelectedUser=[];
     
     if(email.offices.length>0){
      for (let i = 0; i < email.offices.length; i++) {
        var ReqModel={
          officeName:email.offices[i].officeName,
          officeID:email.offices[i].officeID,
          userOfficeID:email.offices[i].userOfficeID,
        }
        this.OfficeUsingSelectedUser.push(ReqModel);
     }
    }
     this.Setasadmin=true;
    // let user= this.peoples.find(m=>m.contactID == email.contactID); 
    // if(user == undefined || user=='' || user == null){
    //   if(email.contactID == 0) {          
    //     return;
    //    }
    //    var  ReqModel={
    //     contactID: email.contactID,
    //     email: email.email,
    //     name: email.name,          
    //     img: email.imageUrl,                    
    //     shortName: email.shortName,
    //    }
    //    //this.peoples.unshift( ReqModel);        
    //    this.stateCtrl.reset();      
    // }
    
 }


}
